import { COHORT_GROWTHBOOK_KEYS_MAP } from 'constants/ab-tests'
import { getGrowthbookVariantData } from 'helpers/getGrowthbookVariantData'
import { useEffect } from 'react'
import { useShallow } from 'zustand/shallow'
import { useZustandStore } from 'zustandGlobalStore'

export const useGetGrowthbookVariantData = (): void => {
  const { cohort, country, growthbook } = useZustandStore(
    useShallow((state) => ({
      cohort: state.lead?.cohort || state.initialCohort,
      country: state.lead?.country || '',
      growthbook: state.growthbook,
    })),
  )

  useEffect(() => {
    const growthbookVariantData = getGrowthbookVariantData({
      growthbook,
      growthbookKey: COHORT_GROWTHBOOK_KEYS_MAP[cohort],
    })

    useZustandStore.setState({ growthbookVariantData })
  }, [growthbook, cohort, country])
}
